// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const includes: MarkdocFunctionSchema = {
  render(parameters): boolean {
    const [array, value] = Object.values(parameters);

    return Array.isArray(array) ? array.includes(value) : false;
  },
};
